export default __webpack_public_path__ + "static/media/contact.fe850acc.png";